import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Flex,
  Box,
  Skeleton,
  HStack,
  Button,
  useToast,
} from "@chakra-ui/react";
import ProductList from "./ProductList";
import NewClientData from "./NewClientData";
import NewOrderData from "./NewOrderData";
import useFetch from "../../../hooks/useFetch";
import { Prompt } from "react-router";
import ConfirmationSwal from "../../../Utils/confirmationSwal";
import Body from "../../Common/Body";

const NewOrderManager = () => {
  const [order, setOrder] = useState({ products: [] });
  const [orderTotal, setOrderTotal] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [userPriceList, setUserPriceList] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { get, post } = useFetch();
  const paramOrderId = useParams().id;
  const history = useHistory();
  const toast = useToast();

  //TODO: reviusar esto
  useEffect(() => {
    setisLoading(false);
  }, []);

  const getOrderTotal = (products) => {
    const totalOrder = products.reduce((total, item) => {
      const itemPriceWithDiscount = item.price * (1 - item.discount / 100);
      const itemTotal = itemPriceWithDiscount * item.qty;
      return total + itemTotal;
    }, 0);
    setOrderTotal(totalOrder);
  };

  const setProducts = async (newProducts) => {
    console.log(newProducts);
    setOrder({ ...order, products: newProducts });
    getOrderTotal(newProducts);
  };

  const setClient = async (client) => {
    get(`/users/${client.id}/admin/price-lists`)
      .then(async (res) => {
        setOrder({ ...order, statusId: 1, userId: client.id, products: [] });
        setUserPriceList(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleSubmit = async (isRedirecting = true) => {
    setIsSubmitting(true);
    let error = "";
    if (!order.statusId) error = "Por favor, ingrese un estado.";
    if (!order.userId) error = "Por favor, ingrese un cliente.";
    if (order.products.length == 0) error = "Por favor, ingrese un artículo.";

    if (error) {
      toast({
        title: "Complete todos los campos.",
        description: error,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      setIsSubmitting(false);
    } else {
      setIsEdited(false);
      post("/orders", order)
        .then((res) => {
          toast({
            title: "Creación de pedido",
            description: "Pedido creado con éxito.",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          if (isRedirecting) {
            history.push("/pedidos");
          } else {
            history.replace("/pedidos");
            history.push(`/pedidos/${res.id}`);
          }
        })
        .catch((e) => {
          toast({
            title: "Se ha producido un error.",
            description:
              e?.message || "Contacte con el administrador del sistema.",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const handleIsEdited = () => {
    setIsEdited(true);
  };

  const handleBlockedNavigation = (nextLocation) => {
    if (isEdited) {
      setIsEdited(false);
      ConfirmationSwal.fire({
        title: "Parece que hay cambios no guardados",
        text: "Desea salir de la página?",
        icon: "question",
        confirmButtonText: "Sí, salir",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          history.push(nextLocation.pathname);
        }
      });
      return false;
    }
    return true;
  };
  return (
    <>
      <Body title={`Pedido ${paramOrderId ?? "Nuevo"}`} isLoading={isLoading}>
        <Flex
          p="0"
          justifyContent="space-between"
          direction={["column", "row"]}
          gap={["0", "2rem"]}
        >
          <NewOrderData total={orderTotal} />
          <NewClientData setClient={setClient}></NewClientData>
        </Flex>
        {userPriceList ? (
          <ProductList
            orderProducts={order.products}
            setProducts={setProducts}
            editable={true}
            priceListsProducts={userPriceList}
            setIsEdited={handleIsEdited}
          ></ProductList>
        ) : (
          <Box p="1rem">
            <Skeleton height="100px"></Skeleton>
          </Box>
        )}
        <HStack
          justify={["center", "flex-end"]}
          mt="2rem"
          wrap={"wrap"}
          gap="0.5rem"
        >
          <Button variant="ghost" onClick={() => history.goBack()}>
            Cancelar
          </Button>
          <Button
            colorScheme="blue"
            isLoading={isSubmitting}
            onClick={() => {
              handleSubmit(true);
            }}
          >
            Guardar
          </Button>
          <Button
            colorScheme="blue"
            isLoading={isSubmitting}
            onClick={() => {
              handleSubmit(false);
            }}
          >
            Guardar y seguir editando
          </Button>
        </HStack>
      </Body>
      <Prompt when={isEdited} message={(e) => handleBlockedNavigation(e)} />
    </>
  );
};

export default NewOrderManager;
